import { create } from "zustand";
import { MessageEntity } from "@/indexedDB/types";

type State = {
  messageToForward: MessageEntity | null;
  isForwardModalOpen: boolean;
  isForwarding: boolean;
};

type Actions = {
  openForwardModal: (message: MessageEntity) => void;
  closeForwardModal: () => void;
  setIsForwarding: (value: boolean) => void;
};

export const useForwardMessageState = create<State & Actions>((set) => ({
  messageToForward: null,
  isForwardModalOpen: false,
  isForwarding: false,

  openForwardModal: (message) => {
    set({ messageToForward: message, isForwardModalOpen: true });
  },

  closeForwardModal: () => {
    set({ isForwardModalOpen: false, messageToForward: null });
  },

  setIsForwarding: (value) => set({ isForwarding: value }),
}));
